import { Routes, Route, Navigate } from 'react-router-dom'
import { Navbar } from './components/Navbar'
import { LoginView } from './views/LoginView'
import { SignupView } from './views/SignupView'
import { ForgotPasswordView } from './views/ForgotPasswordView'
import { ResetPasswordView } from './views/ResetPasswordView'
import { OtpVerificationView } from './views/OtpVerificationView'
import { AccountSessionView } from './views/AccountSessionView'

function App() {
  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginView />} />
          <Route path="/signup" element={<SignupView />} />
          <Route path="/forgot-password" element={<ForgotPasswordView />} />
          <Route path="/reset-password" element={<ResetPasswordView />} />
          <Route path="/otp" element={<OtpVerificationView />} />
          <Route path="/account" element={<AccountSessionView />} />
        </Routes>
      </main>
    </div>
  )
}

export default App
